function AnalyticsPlugin(Vue) {
  const $tag = {
    view(viewName, customData = {}) {
      if (window.utag) {
        window.utag.view({
          view_name: viewName,
          ...customData
        });
      }

      if (process.env.NODE_ENV === "development") {
        console.log("Tagging view:", viewName, customData);
      }
    },

    event(eventName, eventData = {}) {
      if (eventName === "spectrum_init") {
        window.amplitude && window.amplitude.setUserId(eventData);
      } else if (window.utag) {
        window.utag.link({
          event_name: eventName,
          ...eventData
        }, () => {
          if (process.env.NODE_ENV === "development") {
            console.log("Tagging event", eventName, eventData);
          }
        });
      }
    }
  };

  Vue.prototype.$tag = $tag;
}

export default AnalyticsPlugin;